import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { openClose } from '@core/animations/animations';
import { ProfileIdUserMapping } from '@fnModels/stewart';
import { StewartFunctions } from '@functions/stewart.service';
import { BusinessUser, BusinessUserRole } from '@models/businesses';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import LogRocket from 'logrocket';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ICON } from '@core/util/icon';
import { NgForm } from '@angular/forms';

interface LawyeProfileIdMappingVM {
	name: string;
	id: string;
	profileId: string;
}

@Component({
	selector: 'app-stewart-profile-ids',
	templateUrl: './stewart-profile-ids.component.html',
	styleUrls: ['./stewart-profile-ids.component.scss'],
	animations: [openClose()],
	standalone: false,
})
export class StewartProfileIdsComponent implements OnInit {
	public loading = true;
	public loadingError = false;
	public saving = false;
	public savingError = false;
	public mappedLawyers: LawyeProfileIdMappingVM[] = [];
	public ICON = ICON;
	public businessUserRole = BusinessUserRole;

	@SelectSnapshot(BusinessUsersState.getLawyers) lawyers: BusinessUser[];
	@Select(BusinessUsersState.getLoggedInUserRole)
	getUserRole$: Observable<BusinessUserRole>;

	constructor(
		private stewartFunctions: StewartFunctions,
		private matDialogRef: MatDialogRef<StewartProfileIdsComponent>,
	) {}

	ngOnInit(): void {
		this.matDialogRef.addPanelClass('stewart-profile-id-modal');
		this.loadMappings();
	}

	close() {
		this.matDialogRef.close();
	}

	loadMappings() {
		try {
			this.loading = true;

			this.mappedLawyers = this.lawyers.map((lawyer) => {
				const mapping: LawyeProfileIdMappingVM = {
					name: `${lawyer.firstName} ${lawyer.lastName}`,
					id: lawyer.id,
					profileId: lawyer.stewartProfileId ?? null,
				};

				return mapping;
			});
		} catch (err) {
			this.loadingError = true;
			LogRocket.log('Stewart - Unable to get load mappings', err);
		} finally {
			this.loading = false;
		}
	}

	async save(form: NgForm) {
		if (!form.valid) {
			return;
		}

		this.saving = true;

		try {
			const mappings: ProfileIdUserMapping[] = this.mappedLawyers.map((x) => ({
				userId: x.id,
				profileId: x.profileId,
			}));

			await this.stewartFunctions
				.setProfileIds(mappings)
				.pipe(take(1))
				.toPromise();
			this.close();
		} catch (err) {
			this.savingError = true;
			LogRocket.log('Error saving stewart profile id mappings', err);
		} finally {
			this.saving = false;
		}
	}
}
